import React, { DetailedHTMLProps, ImgHTMLAttributes, useState } from 'react';
import LoadingSkeleton from 'components/loading-skeleton';
import NoImage from './no-image';
import styles from './style.module.scss';
import { useThemeContext } from 'contexts/theme';
import { isExpTenant } from '@tenants';

export type ImageProps = DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & {
  isVisible?: boolean;
  width?: string | number | undefined;
  height?: string | number | undefined;
  alt?: string | undefined;
};

export default function Image({ isVisible, width, height, src, alt, ...imgProps }: ImageProps) {
  const [hasValidImage, setHasValidImage] = useState(!!src);
  const { tenantId } = useThemeContext(); // FIXME: This is not the proper way to implement this. NoImage resounces should be configured by theme inside a tenant config and set using normal SVGs and CSS.
  if (!isVisible) {
    return <LoadingSkeleton width={width} height={height} />;
  } else {
    if (hasValidImage) {
      // eslint-disable-next-line @next/next/no-img-element -- Bypassing the rule because we want to use special values for width and height
      return <img
        className={styles.component}
        onError={() => setHasValidImage(false)}
        src={src}
        width={width}
        height={height}
        alt={alt || ''}
        {...imgProps}
      />;
    } else {
      return <NoImage isExpTheme={isExpTenant(tenantId)} />;
    }
  }
}
